/**
 * @generated SignedSource<<41bf9abf664a2315bf02a735a9b14d27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ManageAppsModalFormQuery$variables = {
  id: string;
};
export type ManageAppsModalFormQuery$data = {
  readonly product: {
    readonly __typename: "Product";
    readonly id: string;
    readonly productApps: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly collection: {
            readonly id: string;
          } | null;
          readonly contentUsage: {
            readonly id: string;
          } | null;
          readonly customAppTitle: string | null;
          readonly feed: {
            readonly id: string;
            readonly name: string;
          } | null;
          readonly id: string;
          readonly kind: ProductAppKind;
          readonly " $fragmentSpreads": FragmentRefs<"ChatChannelSettingsModalButtonFragment" | "ChatChannelSideBarItemFragment" | "ContentAppSettingsButtonFragment" | "DeleteChatChannelAppButtonFragment" | "DeleteNavFolderButtonFragment" | "FeedAppSettingsButtonFragment" | "GenericAppSettingsButtonFragment" | "LinkAppSettingsButtonFragment" | "MembersAppSettingsButtonFragment" | "NavFolderSettingsButtonFragment" | "ProductAppListItemFragment">;
        };
      }>;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type ManageAppsModalFormQuery = {
  response: ManageAppsModalFormQuery$data;
  variables: ManageAppsModalFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Feed",
  "kind": "LinkedField",
  "name": "feed",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = [
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsage",
  "kind": "LinkedField",
  "name": "contentUsage",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v19 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v16/*: any*/),
  (v18/*: any*/)
],
v20 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v16/*: any*/),
  (v18/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v17/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v16/*: any*/),
        (v18/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v19/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v16/*: any*/),
        (v18/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v19/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v17/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v17/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v21/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannel",
  "kind": "LinkedField",
  "name": "chatChannel",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalChannelId",
      "storageKey": null
    },
    (v21/*: any*/),
    (v12/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "navSectionId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageAppsModalFormQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductAppNodeConnection",
                "kind": "LinkedField",
                "name": "productApps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductApp",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProductAppListItemFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ContentAppSettingsButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "LinkAppSettingsButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FeedAppSettingsButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "GenericAppSettingsButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ChatChannelSettingsModalButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ChatChannelSideBarItemFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "DeleteChatChannelAppButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "MembersAppSettingsButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "NavFolderSettingsButtonFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "DeleteNavFolderButtonFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ManageAppsModalFormQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductAppNodeConnection",
                "kind": "LinkedField",
                "name": "productApps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductApp",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v23/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductAppNodeConnection",
                            "kind": "LinkedField",
                            "name": "productApps",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductAppNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductApp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v11/*: any*/),
                                      (v5/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v22/*: any*/),
                                      (v7/*: any*/),
                                      (v9/*: any*/),
                                      (v25/*: any*/),
                                      (v23/*: any*/),
                                      (v26/*: any*/),
                                      (v10/*: any*/),
                                      (v24/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductAppNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "productApps",
                                        "plural": false,
                                        "selections": [
                                          (v28/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "072b4beee3a4838b0b04966845c72909",
    "id": null,
    "metadata": {},
    "name": "ManageAppsModalFormQuery",
    "operationKind": "query",
    "text": "query ManageAppsModalFormQuery(\n  $id: ID!\n) {\n  product: node(id: $id) {\n    __typename\n    ... on Product {\n      __typename\n      id\n      productApps {\n        edges {\n          node {\n            id\n            kind\n            customAppTitle\n            feed {\n              id\n              name\n            }\n            collection {\n              id\n            }\n            contentUsage {\n              id\n            }\n            ...ProductAppListItemFragment\n            ...ContentAppSettingsButtonFragment\n            ...LinkAppSettingsButtonFragment\n            ...FeedAppSettingsButtonFragment\n            ...GenericAppSettingsButtonFragment\n            ...ChatChannelSettingsModalButtonFragment\n            ...ChatChannelSideBarItemFragment\n            ...DeleteChatChannelAppButtonFragment\n            ...MembersAppSettingsButtonFragment\n            ...NavFolderSettingsButtonFragment\n            ...DeleteNavFolderButtonFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment ContentAppSettingsButtonFragment on ProductApp {\n  id\n  ...ContentAppSetupModalFragment\n}\n\nfragment ContentAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment DeleteNavFolderButtonFragment on ProductApp {\n  id\n  customAppTitle\n  productApps {\n    totalCount\n  }\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment GenericAppSettingsButtonFragment on ProductApp {\n  id\n  ...GenericAppSettingsModalFragment\n}\n\nfragment GenericAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment LinkAppSettingsButtonFragment on ProductApp {\n  id\n  ...LinkAppSetupModalFragment\n}\n\nfragment LinkAppSetupModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MemberDirectoryAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MembersAppSettingsButtonFragment on ProductApp {\n  id\n  kind\n  productId\n  ...MemberDirectoryAppSettingsModalFragment\n}\n\nfragment NavFolderSettingsButtonFragment on ProductApp {\n  id\n}\n\nfragment ProductAppListItemChildFragment on ProductApp {\n  id\n  kind\n  status\n  customAppTitle\n  customAppUrl\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    slug\n    ...usePermissionsFragment\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  chatChannel {\n    id\n  }\n  ...ContentAppSettingsButtonFragment\n  ...LinkAppSettingsButtonFragment\n  ...FeedAppSettingsButtonFragment\n  ...GenericAppSettingsButtonFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...ChatChannelSideBarItemFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...MembersAppSettingsButtonFragment\n  ...NavFolderSettingsButtonFragment\n  ...DeleteNavFolderButtonFragment\n}\n\nfragment ProductAppListItemFragment on ProductApp {\n  id\n  kind\n  status\n  visibility\n  customAppTitle\n  customAppUrl\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    slug\n    ...usePermissionsFragment\n    id\n  }\n  chatChannel {\n    id\n  }\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n  productApps {\n    edges {\n      node {\n        id\n        ...ProductAppListItemChildFragment\n      }\n    }\n  }\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "6525e1f22529175279771a94a208fe16";

export default node;
